import React from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Home, BookOpen, Plus, TrendingUp, MoreHorizontal } from 'lucide-react';

const tabs = [
  { to: '/dashboard', label: 'Dashboard', icon: Home },
  { to: '/diary', label: 'Diary', icon: BookOpen },
  { to: '/add', label: '', icon: Plus, isAction: true },
  { to: '/progress', label: 'Progress', icon: TrendingUp },
  { to: '/more', label: 'More', icon: MoreHorizontal },
];

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleAdd = () => {
    // Default to Snacks if not in diary; if in diary path, allow snacks add too
    navigate('/add-food/Snacks');
  };

  return (
    <div className="flex flex-col w-full min-h-screen bg-gray-50">
      <main className="flex-1 pb-20 overflow-y-auto no-scrollbar">
        <Outlet />
      </main>

      {/* Bottom Tab Bar */}
      <nav className="fixed bottom-0 left-0 right-0 mx-auto max-w-[480px] bg-white border-t border-gray-200 h-16 flex items-center justify-around z-40"
           style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
        {tabs.map((tab) => {
          const Icon = tab.icon;
          if (tab.isAction) {
            return (
              <button
                key="add"
                onClick={handleAdd}
                className="-mt-8 w-14 h-14 rounded-full bg-[#0066ee] text-white shadow-lg flex items-center justify-center press-scale hover:bg-[#0055cc]"
                aria-label="Add food"
              >
                <Icon size={28} strokeWidth={2.5} />
              </button>
            );
          }
          const isActive = location.pathname.startsWith(tab.to);
          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              className="flex flex-col items-center justify-center flex-1 h-full press-scale"
            >
              <Icon
                size={22}
                className={isActive ? 'text-[#0066ee]' : 'text-gray-500'}
                strokeWidth={isActive ? 2.5 : 2}
              />
              <span className={`text-[11px] mt-1 font-medium ${isActive ? 'text-[#0066ee]' : 'text-gray-500'}`}>
                {tab.label}
              </span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
};

export default Layout;
